import React from "react";
import TableComponent from "./QuestionTable2";

const TableTest1 = () => {
  return (
    <TableComponent
      columns={[
        {
          Header: "Name",
          accessor: "name",
        },
        {
          Header: "Date of Birth",
          accessor: "dob",
        },
        {
          Header: "Contact",
          accessor: "email",
        },
        {
          Header: "Type",
          accessor: "type",
        },
      ]}
      data={[
        {
          name: "Pamela",
          dob: "06/01/1999",
          email: "pam@x.com",
          type: "Short Answer",
        },
        {
          name: "Jim",
          dob: "06/01/1999",
          email: "jim@x.com",
          type: "Short Answer",
        },
        {
          name: "Michael",
          dob: "06/01/1999",
          email: "mike@x.com",
          type: "Short Answer",
        },
      ]}
      withCheckbox
      withSearch
      withPagination
      onRowSelect={(selected) => console.log("Selected:", selected)}
      onRowReorder={(newOrder) => console.log("New Order:", newOrder)}
      customActions={(row) => <a href="/">See Application</a>}
    />
  );
};

export default TableTest1;
